<!-- 抽奖 -->
<template>
  <div :class="$style.lottery">
    <!-- 转盘抽奖 -->
    <the-lottery-wheel
      :data-source="lotteryData"
      @login="$emit('login')"
      @bind-address="onBindAddress"
      @go-team="$emit('go-team')"
    />

    <!-- 剩余抽奖次数 -->
    <div
      style="
        position: absolute;
        top: 2.78rem;
        right: 6.2rem;
        color: #ffd852;
        transform: rotate(-45deg);
        transform-origin: 100% 50%;
      "
    >
      {{ lotteryCount }}
    </div>

    <div style="margin-top: 0.8rem; position: relative; text-align: center">
      <!-- 获取更多抽奖机会 -->
      <button
        v-if="!hasAllLotteryCoupon"
        :disabled="completeLottery"
        :class="$style['btn-more']"
        :style="isBindRole ? { marginLeft: '1.2rem' } : {}"
        @click="handleMore"
      />

      <!-- 查看我的奖励 -->
      <button v-if="isBindRole" :class="$style['btn-award']" @click="$emit('show-records')">
        获奖记录
      </button>
    </div>

    <!-- 抽奖规则 -->
    <div
      style="margin: 0.45rem 0.3rem 0; color: #ffde98; line-height: 1.5"
      v-html="lotteryData.rule"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheLotteryWheel from '@/components/TheLotteryWheel'

export default {
  name: 'TheLottery',
  components: { TheLotteryWheel },
  props: {
    /** 抽奖配置数据 */
    lotteryData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['lotteryCount', 'isBindRole', 'completeLottery', 'hasAllLotteryCoupon'])
  },
  methods: {
    handleMore() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }
      // 跳转到组队赢好礼
      this.$emit('go-team')
    },
    onBindAddress(prizeName) {
      this.$emit('bind-address', prizeName)
    }
  }
}
</script>

<style lang="less" module>
.lottery {
  .background-fill('./images/lottery-bg.jpg');

  position: relative;
  height: 14.35rem;
  padding-top: 2.85rem;
}

.btn-more {
  .size(3.86rem, 0.86rem);
  .background-fill('./images/btn-more.png', 100% 200%);

  &:disabled {
    background-position: 0 100%;
  }
}

.btn-award {
  position: relative;
  top: -0.1rem;
  margin-left: 0.3rem;
  border-bottom: 1px solid #ffb8af;
  color: #ffb8af;
}
</style>
